/** Shared column definitions and helpers for heatmap views */

import type { ActivityTypeBreakdown } from '../../types/emissions';

export const SCOPE_COLUMNS = [
  { key: 'scope1', label: 'Scope 1' },
  { key: 'scope2', label: 'Scope 2' },
  { key: 'scope3', label: 'Scope 3' },
];

export const ACTIVITY_COLUMNS = [
  { key: 'stationary_combustion', label: 'Stationary' },
  { key: 'mobile_combustion', label: 'Mobile' },
  { key: 'fugitive_emissions', label: 'Fugitive' },
  { key: 'process_emissions', label: 'Process' },
  { key: 'purchased_electricity', label: 'Electricity' },
  { key: 'purchased_heating', label: 'Heating' },
  { key: 'purchased_steam', label: 'Steam' },
  { key: 'purchased_cooling', label: 'Cooling' },
];

export const buildActivityValuesFromBreakdown = (
  activityTypes: ActivityTypeBreakdown[],
): Record<string, number> => {
  const values: Record<string, number> = {};
  for (const { activityType, co2e } of activityTypes) {
    values[activityType] = (values[activityType] ?? 0) + co2e;
  }
  return values;
};
